import { Component, Inject, OnInit } from '@angular/core';
import { ReusableClasses } from '../reusableclassesAndFunctions/reusable-classes';
import { EncryptionService } from '../../encryption/encryption.service';
import * as jwt_decode from 'jwt-decode';
import { FormGroup, FormBuilder } from '@angular/forms';
import { CoreService } from 'src/app/applicationModules/core/services/coreService/core.service';
import { ToastrService } from 'ngx-toastr';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { StatusConstant } from '../status/status-constant';
import { LoaderService } from '../../shared/loader/loader.service';
import { Clipboard } from "@angular/cdk/clipboard";

@Component({
  selector: 'app-signaturesDataShow',
  templateUrl: './signaturesDataShow.component.html',
  styleUrls: ['./signaturesDataShow.component.scss'],
})

export class SignaturesDataShowComponent implements OnInit {
  organizationId: string;
  databaseId: string;
  currentUser: any;
  responseHolder: any;
  formDialog: FormGroup;
  spinner: boolean = false;
  OfficeIDList: any = [];
  myOfficeID: any;

  inboxProjectsList: any = [] = [];
  sentProjectsList: any = [] = [];
  draftProjectsList: any = [] = [];
  noRecordFoundInbox: boolean = false;
  noRecordFoundSent: boolean = false;
  noRecordFounddraft: boolean = false;

  pageModelData = {
    pageIndex: 0,
    pageSize: 100,
    searchValue: '',
  };
  OpenFrom: string = "";
  LoggedInEmailId: string = "";


  constructor(public dialogRef: MatDialogRef<SignaturesDataShowComponent>,
    private formBuilder: FormBuilder, private encryptionAlgo: EncryptionService,
    private reusableClass: ReusableClasses, private coreService: CoreService,
    private toastr: ToastrService, private statusConstant: StatusConstant, @Inject(MAT_DIALOG_DATA) public data: any,
    private loaderService: LoaderService, private dialog: MatDialog,
    private clipboard: Clipboard) {

    const encryptedtoken = sessionStorage.getItem('userToken');
    this.databaseId = sessionStorage.getItem('databaseId')?? '';
    this.organizationId = sessionStorage.getItem('organizationID')?? '';
    this.LoggedInEmailId = sessionStorage.getItem('email')?? '';
    const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);
    this.currentUser = jwt_decode(token);
    var offices = JSON.parse(sessionStorage.getItem('officeList'));
    offices.forEach(oe => {
      this.OfficeIDList.push(oe.officeID)
      if (oe.isMyoffice == true)
        this.myOfficeID = oe.officeID;
    });
  }

  ngOnInit(): void {
    if (this.data.openFrom == "ReadyToSign") {
      this.OpenFrom = "ReadyToSign";
      this.getInboxProjects(this.pageModelData);
    }
    if (this.data.openFrom == "Pending") {
      this.OpenFrom = "Pending";
      this.getSentProjects(this.pageModelData);
    }
    if (this.data.openFrom == "Drafts") {
      this.OpenFrom = "Drafts";
      this.getDraftedProjects(this.pageModelData);
    }

  }

  // ==== For ReadyToSign ====//
  getInboxProjects(pageData: any) {
    var ReqModel = {
      pageIndex: this.pageModelData.pageIndex,
      pageSize: this.pageModelData.pageSize,
      searchKey: this.pageModelData.searchValue,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      officeID: this.myOfficeID,
      officeIDList: this.OfficeIDList
    }
    this.coreService.getInboxProjects(ReqModel).subscribe(response => {
      if (response.data != null) {
        this.inboxProjectsList = response.data.sentOrInboxListModelList;
        this.inboxProjectsList = this.inboxProjectsList.filter((m:any) => m.status == 0 || m.status == 2);
        this.inboxProjectsList.forEach((e:any) => {
          e.signHref =
            window.location.href.split(window.location.pathname)[0] +
            "/request/signature?token=" +
            e.signingToken +
            "&signnowFrom=" +
            encodeURIComponent(this.LoggedInEmailId);
        });
        if (this.inboxProjectsList.length > 0) {
          this.noRecordFoundInbox = false;
        } else {
          this.noRecordFoundInbox = true;
        }
      }else {
        this.inboxProjectsList=[];
        this.noRecordFoundInbox = true;
      }
    });
  }

  // ==== For Pending ====//
  getSentProjects(pageData: any) {
    var ReqModel = {
      pageIndex: this.pageModelData.pageIndex,
      pageSize: this.pageModelData.pageSize,
      searchKey: this.pageModelData.searchValue,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      officeID: this.myOfficeID,
      officeIDList: this.OfficeIDList
    }
    this.coreService.getSentProjects(ReqModel).subscribe(response => {
      if (response.data != null) {
        this.sentProjectsList = response.data.sentOrInboxListModelList;
        if (this.sentProjectsList.length > 0) {
          this.noRecordFoundSent = false;
        } else {
          this.noRecordFoundSent = true;
        }
      } else {
        this.sentProjectsList=[];
        this.noRecordFoundSent = true;
      }
    });
  }

  // ==== For Drafts ====//
  getDraftedProjects(pageData: any) {
    var ReqModel = {
      projectStatus: 1,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      searchKey: this.pageModelData.searchValue,
      pageIndex: pageData.pageIndex,
      pageSize: pageData.pageSize,
      officeID: this.myOfficeID,
      officeIDList: this.OfficeIDList
    }
    this.coreService.getDraftedProjects(ReqModel).subscribe(response => {
      if (response.data != null) {
        this.draftProjectsList = response.data.projects;
        if (this.draftProjectsList.length > 0) {
          this.noRecordFounddraft = false;
        } else {
          this.noRecordFounddraft = true;
        }
      } else {
        this.draftProjectsList=[];
        this.noRecordFounddraft = true;
      }
    });
  }


  OpenDetailsSent(sent) {
    sessionStorage.setItem('MasterTemplatePDFForm', 'false');
    sessionStorage.setItem('MasterTemplateTabularForm', 'false');
    sessionStorage.setItem('MasterOrgTemplatePDFForm', 'false');
    sessionStorage.setItem('MasterTemplateWebForm', 'false');
    //this._dataSharingService.SendCurrentFormContact(null);
    //this._dataSharingService.sendSentSelectedDetail(sent);
    window.open('/esignature/sent', '_blank');
    //  this.router.navigate(['/esignature/sent']);
  }

  OpenProjectDeatils(project) {
    // this._dataSharingService.SendCurrentFormContact(null);
    sessionStorage.setItem('ProjectName', project.projectName);
    sessionStorage.setItem('projectID', project.projectID);
    sessionStorage.setItem('stepCompleted', project.stepCompleted);
    sessionStorage.setItem('type', '1');
    sessionStorage.setItem('ImportTemplateShow', 'true');
    sessionStorage.setItem('MasterTemplatePDFForm', 'false');
    sessionStorage.setItem('MasterTemplateTabularForm', 'false');
    sessionStorage.setItem('MasterOrgTemplatePDFForm', 'false');
    sessionStorage.setItem('MasterTemplateWebForm', 'false');
    sessionStorage.setItem('isSharedWithMeForm', 'false');
    if (project.stepCompleted == 0) {
      window.open('/esignature/first', '_blank');
      // this.router.navigate(['/esignature/first']);
    }
    else if (project.stepCompleted == 1) {
      window.open('/esignature/second', '_blank');
      //this.router.navigate(['/esignature/second']);
    }
    else if (project.stepCompleted == 2) {
      window.open('/esignature/third', '_blank');
      // this.router.navigate(['/esignature/third']);
    }
    else if (project.stepCompleted == 3 || project.stepCompleted == 4) {
      window.open('/esignature/four', '_blank');
      //this.router.navigate(['/esignature/four']);
    }
    // this._dataSharingService.sendSelectedFolderContentFromLeftMenu(null);
  }

   OpenTablarDeatils(project) {
    if (project.token != null) {
      let formSigningLink = window.location.href.split(window.location.pathname)[0] + "/request/tabularsignature?token=" + project.token;
      window.open(formSigningLink, "_blank");
    }
  }

  closeTask() {
    this.dialogRef.close();
  }

  ViewAll(view:string){
    if(view=="inbox"){
     window.open('/esignature/inbox', '_blank');
    }
    if(view=="sent"){
     window.open('/esignature/sent', '_blank');
    }
    if(view=="draft"){
     window.open('/esignature/draft', '_blank');
    }
   
  }


}


